import { render, staticRenderFns } from "./shopifyAuthorzation.vue?vue&type=template&id=2c3cb86b&scoped=true&"
import script from "./shopifyAuthorzation.vue?vue&type=script&lang=js&"
export * from "./shopifyAuthorzation.vue?vue&type=script&lang=js&"
import style0 from "./shopifyAuthorzation.vue?vue&type=style&index=0&id=2c3cb86b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3cb86b",
  null
  
)

export default component.exports